:host {
  display: block;
  min-width: 0;
  width: 100%;
}

sc-choice-container {
  container-type: inline-size;
}

.price-choice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: var(--sc-line-height-dense);
  gap: var(--sc-spacing-small);

  &__name {
    display: inline-block;
    font-size: var(--sc-price-choice-name-size, var(--sc-input-label-font-size-medium));
    font-weight: var(--sc-price-choice-name-font-weight, var(--sc-font-weight-bold));
    text-transform: var(--sc-price-choice-text-transform, var(--sc-input-label-text-transform, none));
  }

  > *:not(:first-child):last-child {
    text-align: right;
  }

  &__details {
    flex: 1 0 50%;
    display: grid;
    gap: var(--sc-spacing-xxx-small);
  }

  &__trial,
  &__setup-fee,
  &__price {
    font-size: var(--sc-font-size-small);
    opacity: 0.8;
  }

  &__price {
    font-weight: var(--sc-price-choice-price-font-weight, var(--sc-font-weight-normal));
  }

  &__bundle-savings {
    font-size: var(--sc-font-size-x-small);
    font-weight: var(--sc-font-weight-semibold);
    color: var(--sc-color-success-700, #15803d);
  }
}

@container (max-width: 325px) {
  .price-choice {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--sc-spacing-xx-small);
    > *:not(:first-child):last-child {
      text-align: initial;
    }
  }
}
